import {deepmerge} from 'deepmerge-ts';

import {core as coreLegacy, semantic as semanticLegacy} from '../design-tokens/light-legacy';
import {components, core, prefix, semantic} from '../design-tokens/light';

import {autoSizeTextareaTheme} from './components/AutoResizeTextarea';
import {avatarSelectTheme} from './components/AvatarSelect';
import {badgeTheme} from './components/Badge';
import BreadcrumbTheme from './components/Breadcrumb';
import ButtonTheme from './components/Button/Button';
import IconButtonTheme from './components/Button/IconButton';
import CardTheme from './components/Card';
import {ChartTooltipTheme} from './components/ChartTooltip';
import {checkboxTheme} from './components/Checkbox';
import {contextMenuTheme} from './components/ContextMenu';
import {datePickerTheme} from './components/DatePicker';
import DrawerTheme from './components/Drawer';
import {editableFieldsTheme} from './components/EditableFields';
import {editableFormControlTheme} from './components/EditableFormControl';
import {editableTheme} from './components/Editable';
import FormControlTheme from './components/FormControl';
import {formErrorTheme} from './components/FormError';
import {formLabelTheme} from './components/FormLabel';
import {formSectionTheme} from './components/FormSection';
import {inputTheme} from './components/Input';
import MenuTheme from './components/Menu';
import {ModalTheme} from './components/Modal';
import NavbarTheme from './components/Navbar';
import {numberInputTheme} from './components/NumberInput';
import PaginationTheme from './components/Pagination/PaginationTheme';
import Pagination from './components/Pagination/Pagination';
import {PopoverTheme} from './components/Popover';
import {progressTheme} from './components/Progress';
import {radioButtonGroupTheme} from './components/RadioButtonGroup/RadioButtonGroup';
import {selectTheme} from './components/Select';
import StatTheme from './components/Stat';
import StepperTheme from './components/Stepper';
import {switchTheme} from './components/Switch';
import TableTheme from './components/Table/Table';
import TableFiltersTheme from './components/TableFilters';
import {TabsTheme} from './components/Tabs';
import {tagTheme} from './components/Tag';
import {textareaTheme} from './components/Textarea';
import {toastTheme} from './components/Toast';
import {tooltipTheme} from './components/Tooltip';
import {core as coreComplex} from './tokens';

export const coreTokens = deepmerge(coreLegacy, coreComplex);
export const linxTheme = {
  config: {
    initialColorMode: `light`,
    useSystemColorMode: false,
    cssVarPrefix: prefix,
  },

  ...deepmerge(coreLegacy, coreComplex, core),
  components: {
    AutoSizeTextarea: autoSizeTextareaTheme,
    AvatarSelect: avatarSelectTheme,
    Badge: badgeTheme,
    Breadcrumb: BreadcrumbTheme,
    Button: ButtonTheme,
    Card: CardTheme,
    Checkbox: checkboxTheme,
    ContextMenu: contextMenuTheme,
    DatePicker: datePickerTheme,
    Drawer: DrawerTheme,
    Editable: editableTheme,
    EditableFields: editableFieldsTheme,
    EditableFormControl: editableFormControlTheme,
    FormSection: formSectionTheme,
    Form: FormControlTheme,
    FormError: formErrorTheme,
    FormLabel: formLabelTheme,
    IconButton: IconButtonTheme,
    Input: inputTheme,
    Menu: MenuTheme,
    Modal: ModalTheme,
    Navbar: NavbarTheme,
    NumberInput: numberInputTheme,
    // TODO(PRE-1122): rename PaginationTheme to Pagination and remove old one after applying pagination to tables
    Pagination,
    PaginationTheme,
    Popover: PopoverTheme,
    Progress: progressTheme,
    RadioButtonGroup: radioButtonGroupTheme,
    Select: selectTheme,
    Stat: StatTheme,
    Stepper: StepperTheme,
    Switch: switchTheme,
    Table: TableTheme,
    TableFilters: TableFiltersTheme,
    Tabs: TabsTheme,
    Tag: tagTheme,
    Textarea: textareaTheme,
    Tooltip: tooltipTheme,
    Toast: toastTheme,
    ChartTooltip: ChartTooltipTheme,
  },
  semanticTokens: deepmerge(semanticLegacy, semantic, components),
};
